module.exports = __webpack_public_path__ + "e41e0746656b498ba5016f0404926606.svg";